export const satislar = [
    {value: null, label: 'Kiralık'},
    {value: 'demo', label: 'Demo'},
];


export const kokuMililiters = [
    {value: 25, label: '25 ml'},
    {value: 50, label: '50 ml'},
    {value: 75, label: '75 ml'},
    {value: 100, label: '100 ml'},
    {value: 150, label: '150 ml'},
    {value: 200, label: '200 ml'},
];
